import React from 'react';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { UserShape, TackNotificationDetailsShape } from '../shapes';
import BeingTackedBy from './being_tacked_by';
import Comments from '../containers/comments';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';

export default class TackNotificationDetails extends React.Component {
  static propTypes = {
    loadComments: PropTypes.bool,
    user: UserShape,
    tackNotificationDetails: TackNotificationDetailsShape
  }

  render() {
    const definitionList = this.props.tackNotificationDetails.get('definitions').map((definitionText, i) => { return(<li key={i}>{ definitionText }</li>) });
    return(
      <div className='tack-notification-details'>
        <div className='word'>
          <div className='item-meta'>
            <BeingTackedBy tackedBy={this.props.tackNotificationDetails.get('tackedBy')} tacksCount={this.props.tackNotificationDetails.get('tacksCount')} />
          </div>
        </div>
        <ol className='definition-text give-me-10-top'>{definitionList}</ol>
        <p className='example-text'>
          { this.props.tackNotificationDetails.get('exampleText') }
        </p>
        { this.renderYouAreFinished() }
        { this.renderFreeTheQueue() }
        <div className='action'>
          <Link to='/tack_board' className='btn btn-dark'>Done</Link>
        </div>
        { this.renderComments() }
      </div>
    );
  }

  renderYouAreFinished() {
    if (this.props.tackNotificationDetails.get('tackInterval') === 13) {
      return (
        <div className='secondary-background meta-section'>
          <b>You finished tacking { this.props.tackNotificationDetails.get('wordText') }</b>!
        </div>
      )
    } else return null;
  }

  renderFreeTheQueue() {
    if (this.props.user.get('queuedTacksCount') > 0) {
      return (
        <div className='secondary-background meta-section'>
          You have { pluralize('tack', this.props.user.get('queuedTacksCount'), true) } in queue.
          &nbsp;<Link to='/plans'>Unlock the queue</Link>.
        </div>
      );
    } else return null;
  }

  renderComments() {
    if (this.props.loadComments) {
      return (
        <Fragment>
          <div className='give-me-55-top'></div>
          <Comments wordText={ this.props.tackNotificationDetails.get('wordText') }/>
        </Fragment>
      )
    } else return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/tack_notification_details.jsx